import { api } from '../lib/request';

export function requestPasswordReset(email) {
  return api.post('/users/password-reset/request', { email });
}
